import { createChannelManagementInstance } from '../api-instance';

export interface TelegramAuthResult {
  status: 'sms_sent' | 'password_required' | 'authorized';
  step: 'code' | 'email' | 'email_setup_code' | 'password' | 'ready';
  delivery?: 'telegram' | 'sms' | 'email' | 'fragment';
  code_length?: number;
  email_pattern?: string;
  fragment_url?: string;
  can_resend?: boolean;
  resend_available_at?: string;
}

const post = (channelId: string, path: string, data: object) =>
  createChannelManagementInstance<TelegramAuthResult>({
    url: `/api/v1/channels/${encodeURIComponent(channelId)}/${path}`,
    method: 'POST',
    data,
  });

export const initTelegramPhoneAuth = (
  channelId: string,
  data: { phone: string }
) => post(channelId, 'init_sms', data);

export const verifyTelegramPhoneCode = (
  channelId: string,
  data: { phone: string; code: string }
) => post(channelId, 'verify_sms', data);

export const resendTelegramCode = (channelId: string) =>
  post(channelId, 'telegram/resend-code', {});

export const submitTelegramEmail = (
  channelId: string,
  data: { email: string }
) => post(channelId, 'telegram/email', data);

export const verifyTelegramEmail = (
  channelId: string,
  data: { code: string }
) => post(channelId, 'telegram/verify-email', data);
